import { Clock, Warning, FireSimple } from "@phosphor-icons/react";
import { computeAging, reqAgingSince, agingClasses } from "@/lib/aging";

// Small pill shown next to a REQ's status while it's still grey or yellow.
// Colour ramps: fresh (neutral) < 24h → warn (amber) 24-72h → overdue (red) > 72h.
export default function AgingPill({ req, showLabel = true, testid }) {
  const since = reqAgingSince(req);
  if (!since) return null;
  const { tone, label } = computeAging(since);
  const Icon = tone === "overdue" ? FireSimple : tone === "warn" ? Warning : Clock;
  const prefix = req.status === "verified" ? "verified" : "waiting";
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 border text-[10px] font-mono uppercase tracking-wider ${agingClasses(tone)}`}
      data-testid={testid || `aging-${tone}`}
      title={`${prefix} for ${label}`}
    >
      <Icon size={10} weight="bold" />
      {showLabel && <span>{label}</span>}
    </span>
  );
}
